/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Involvement_AnswerInputs */

const en_faq_involvement_answer = /** @type {(inputs: Faq_Involvement_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We need input from people who understand the work, access to relevant examples and feedback during testing. We agree who is involved and what we need from them as part of the project plan.`)
};

const lv_faq_involvement_answer = /** @type {(inputs: Faq_Involvement_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mums vajadzīgs ieguldījums no cilvēkiem, kas saprot darbu, piekļuve atbilstošiem piemēriem un atgriezeniskā saite pārbaudes laikā. Kas iesaistās un kas no viņiem nepieciešams, saskaņojam projekta plānā.`)
};

/**
* | output |
* | --- |
* | "We need input from people who understand the work, access to relevant examples and feedback during testing. We agree who is involved and what we need from th..." |
*
* @param {Faq_Involvement_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_involvement_answer = /** @type {((inputs?: Faq_Involvement_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Involvement_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_involvement_answer(inputs)
	return en_faq_involvement_answer(inputs)
});